import TableButton from '../../components/Table/TableButton/TableButton';
import { FaPen ,FaTrashAlt } from 'react-icons/fa';
import { fmtValue } from '../../utils/format';
export const machineColumns = (openModal, clickDelete, openFileModal) => [
    { header: '구축일', accessor: 'setupDt' },
    { header: '제품명', accessor: 'machineName' },
    { header: '규격', accessor: 'specification' },
    { header: '설비코드', accessor: 'machineCode' },
    { header: 'Iot ID', accessor: 'deviceId' },
    { header: 'Channel', accessor: 'ch',
        render: (row) => {
            const typeMap = {
                1: 'Ch.1',
                2: 'Ch.2',
                3: 'Ch.3',
            };
            return typeMap[row.ch]
        }
    },
    { header: '제조사', accessor: 'makeCompany', render: (row) => {}},
    { header: '매입가격', accessor: 'price', render: (row) => `${row.price.toLocaleString()} 원` },
    { header: '상태', accessor: 'status' },
    // { header: '러닝타임', accessor: 'runtime', render: (row) => `${row.runtime} 시간` },
    { header: '전원 최솟값', accessor: 'power',   render: (row) => fmtValue(row.power) },
    { header: '가동 최솟값', accessor: 'operate', render: (row) => fmtValue(row.operate) },
    // { header: '상세보기', accessor: 'details', render: (row) => <TableButton text="상세보기" onClick={(e) => {e.stopPropagation();}} /> },
    { header: '첨부파일', accessor: 'attachments', render: (row) => <span onClick={(e) => {e.stopPropagation(); openFileModal(row)}}>📎</span> },
    { header: '수정',accessor: 'update', render: (row) =>
        <span onClick={(e) => { e.stopPropagation(); openModal(2, row)}} style={{ cursor: 'pointer' }}><FaPen/></span>
    },
    { header: '삭제', accessor: 'delete', render: (row) =>
        <span onClick={(e) => { e.stopPropagation(); clickDelete(row); }} style={{ cursor: 'pointer' }}><FaTrashAlt/></span>
    },
];
export const machineSearchFormFields = [
    { key: "processName", label: "공정명", type: "text", size: 6, visible: true },
    { key: "processCode", label: "공정 코드", type: "text", size: 6, visible: true },
    { key: "processFee", label: "공임비", type: "number", size: 6, visible: true },
    { key: "userSeq", label: "담당자", type: "apiSelect", apiKey: "user", labelKey: "userName", valueKey: "userSeq", visible: true },
    { key: "devDt", label: "개발일", type: "date", size: 6, visible: true },
];
export const machineFormFields = [
    { key: "machineSeq", label: "공정번호", type: "text", size: 6, visible: false, required: false },
    { key: "companySeq", label: "회사번호", type: "text", size: 6, visible: false, required: false },
    { key: "setupDt", label: "구축일", type: "date", size: 6, visible: true, required: false },
    { key: "machineName", label: "설비명", type: "text", size: 6, visible: true, required: true },
    { key: "specification", label: "규격", type: "text", size: 6, visible: true, required: false },
    { key: "machineCode", label: "설비 코드", type: "text", size: 6, visible: true, required: false },
    { key: "deviceId", label: "Iot ID", type: "text", size: 6, visible: true, required: true },
    { key: "ch",
        label: "채널",
        type: "select",
        size: 6,
        visible: true,
        required: true,
        options: [
            { label: "Ch.1", value: 1 },
            { label: "Ch.2", value: 2 },
            { label: "Ch.3", value: 3 },
        ],
        default: 1
    },
    { key: "power", label: "전원 최솟값", type: "number", size: 6, visible: true, required: false },
    { key: "operate", label: "가동 최솟값", type: "number", size: 6, visible: true, required: false },
    { key: "makeCompany", label: "제조사", type: "text", size: 6, visible: true, required: false },
    { key: "price", label: "가격", type: "number", size: 6, visible: true, required: false },
    { key: "status", label: "상태", type: "text", size: 6, visible: true, required: false },
]